import { useMemo, type ChangeEvent } from 'react'
import { dsv } from '../../../styles/defaults'

import type { InputProps } from '.'

export function InputDate({ fieldId, strValue, setStrValue, saveStrValue, style }: InputProps) {
  const { onChange } = useMemo(
    () => ({
      onChange:
        setStrValue == undefined || saveStrValue == undefined
          ? undefined
          : (event: ChangeEvent<HTMLInputElement>) => saveStrValue(event.target.value),
    }),
    [setStrValue, saveStrValue]
  )

  return (
    <input
      type="date"
      id={fieldId}
      value={strValue}
      disabled={onChange == undefined}
      onChange={onChange}
      // TODO: Fix styling for App Version
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      style={{ height: 24, ...dsv.text, ...style }}
    />
  )
}
